import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const QRCodeSection = () => {
  return (
    <section className="py-20 px-4 lg:px-8 bg-card">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            Scan & Download Instantly
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Point your phone camera at the QR code to download Signaly directly to your device
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-background border border-border rounded-2xl p-8 text-center hover:shadow-cyan-glow transition-all duration-200">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6">
              <Icon name="DevicePhoneMobileIcon" size={32} className="text-primary" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-foreground mb-4">iOS App</h3>
            <div className="bg-white p-6 rounded-xl mb-6 inline-block">
              <AppImage
                src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://apps.apple.com/signaly"
                alt="QR code for downloading Signaly iOS app from Apple App Store"
                className="w-48 h-48"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Scan with your iPhone camera to download from App Store
            </p>
            <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              <span>iOS 14.0 or later</span>
            </div>
          </div>

          <div className="bg-background border border-border rounded-2xl p-8 text-center hover:shadow-cyan-glow transition-all duration-200">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6">
              <Icon name="DevicePhoneMobileIcon" size={32} className="text-primary" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-foreground mb-4">Android App</h3>
            <div className="bg-white p-6 rounded-xl mb-6 inline-block">
              <AppImage
                src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://play.google.com/store/apps/signaly"
                alt="QR code for downloading Signaly Android app from Google Play Store"
                className="w-48 h-48"
              />
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Scan with your Android camera to download from Google Play
            </p>
            <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              <span>Android 8.0 or later</span>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground mb-4">
            Having trouble scanning? Enter your phone number to receive a download link
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="tel"
              placeholder="Enter your phone number"
              className="flex-1 px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-heading font-semibold hover:scale-105 transition-all duration-200 shadow-cyan-glow">
              Send Link
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QRCodeSection;